import { PaymentMethodTypes } from "@/models/investor.model";

export function mapPaymentMethodToPixKeyType(
  method: PaymentMethodTypes | string
): string {
   if(method === PaymentMethodTypes.DOCUMENT) return "DOCUMENT";
  if(method === PaymentMethodTypes.EMAIL) return "EMAIL";
  if(method === PaymentMethodTypes.BANK_ACCOUNT) return "BANK_ACCOUNT"; 
  if (method == PaymentMethodTypes.PHONE) return "PHONE";
  return method.toString();
}

export function mapPixKeyTypeToLabel(pixKeyType: string): string {
  switch (pixKeyType) {
    case "PHONE":
      return "Celular";
    case "DOCUMENT":
      return "CPF";
    case "EMAIL":
      return "Email";
    case "BANK_ACCOUNT":
      return "Dados Bancários";
    default:
      return "Desconhecido";
  }
}
